import { AuthController } from '@controllers/auth-controller';
import {
  CAMPAIGN_TRANSFER,
  PAYMENT_METHOD_TRANSFER,
  PAYMENT_PROFILE_TRANSFER,
  REVIEW_BILLING_DETAILS_TRANSFER,
  TAX_PROFILE_TRANSFER,
} from '@utils/controller-utils';
import { codeSplit } from 'bernie-core';

export class CampaignTransferController extends AuthController {
  public pageId = CAMPAIGN_TRANSFER;
  public path = '/partner/migration-wizard/transfer-campaigns';
  public routeName = 'campaign-transfer';
  public bundles = [];
  public pageTitle = 'controllers.transfer.campaigns';
  public accessRoles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "onboarding" */ '@views/partner/migration-wizard/transfer-campaigns'),
  );
  public exact = false;
  public isPartnerProtected = false;
  public isPartnerView = true;
  public isAdminView = true;
}

export class PaymentProfileTransferController extends AuthController {
  public pageId = PAYMENT_PROFILE_TRANSFER;
  public path = '/partner/migration-wizard/payment-profile';
  public routeName = 'payment-profile';
  public bundles = [];
  public pageTitle = 'controllers.transfer.paymentProfile';
  public accessRoles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "onboarding" */ '@views/partner/migration-wizard/payment-profile'),
  );
  public exact = false;
  public isPartnerProtected = false;
  public isPartnerView = true;
  public isAdminView = true;
}

export class PaymentMethodTransferController extends AuthController {
  public pageId = PAYMENT_METHOD_TRANSFER;
  public path = '/partner/migration-wizard/payment-method';
  public routeName = 'payment-method';
  public bundles = [];
  public pageTitle = 'controllers.transfer.paymentMethod';
  public accessRoles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "onboarding" */ '@views/partner/migration-wizard/payment-method'),
  );
  public exact = false;
  public isPartnerProtected = false;
  public isPartnerView = true;
  public isAdminView = true;
}

export class TaxProfileTransferController extends AuthController {
  public pageId = TAX_PROFILE_TRANSFER;
  public path = '/partner/migration-wizard/tax-profile';
  public routeName = 'tax-profile';
  public bundles = [];
  public pageTitle = 'controllers.transfer.taxProfile';
  public accessRoles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "onboarding" */ '@views/partner/migration-wizard/tax-profile'),
  );
  public exact = false;
  public isPartnerProtected = false;
  public isPartnerView = true;
  public isAdminView = true;
}

export class ReviewBillingDetailsTransferController extends AuthController {
  public pageId = REVIEW_BILLING_DETAILS_TRANSFER;
  public path = '/partner/migration-wizard/review-billing-details';
  public routeName = 'review-billing-details';
  public bundles = [];
  public pageTitle = 'controllers.transfer.reviewBillingDetails';
  public accessRoles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "onboarding" */ '@views/partner/migration-wizard/review-billing-details'),
  );
  public exact = false;
  public isPartnerProtected = false;
  public isPartnerView = true;
  public isAdminView = true;
}
